import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Filings from './pages/filings/Filings';
import AdvancedSearch from './pages/advancedSearch/AdvancedSearch';
import AdvancedSearchIR from './pages/advancedSearch/AdvancedSearchIR';
import ErrorBoundary from './ErrorBoundary';
import { isCourtDrive } from './util/globalUtils';

/**
 * Note for HMR, these 4 components must have an error in them somewhere
 * I can get HMR to work on a temp component, but these might be importing some weird js someplace
 */
class App extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Router>
          <div>
            <Route path="/filings/:tab" component={Filings} />
            <Route exact path="/filings" render={() => <Redirect to="/filings/search-court-filings" />} />

            {isCourtDrive() ? (
              <Switch>
                <Route path="/advanced-search/:courtType/:tab" component={AdvancedSearch} />
                <Route
                  exact
                  path="/advanced-search"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/all/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/all"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/all/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/bankruptcy"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/bankruptcy/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/civil"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/civil/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/criminal"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/criminal/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/appellate"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/appellate/general', search: location.search }} />
                  )}
                />
              </Switch>
            ) : (
              <Switch>
                <Route path="/advanced-search/:courtType/:tab" component={AdvancedSearchIR} />
                <Route
                  exact
                  path="/advanced-search"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/bankruptcy/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/bankruptcy"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/bankruptcy/general', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/extended"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/bankruptcy/petitions', search: location.search }} />
                  )}
                />
                <Route
                  exact
                  path="/advanced-search/schedules"
                  render={({ location }) => (
                    <Redirect to={{ pathname: '/advanced-search/bankruptcy/schedules', search: location.search }} />
                  )}
                />
              </Switch>
            )}
          </div>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx